import type { RootState } from './store';

export function selectAnyRequestPending(state: RootState): boolean {
  const hub = state.hubApi ?? { queries: {}, mutations: {} };
  const resource = state.resourceApi ?? { queries: {}, mutations: {} };
  const all = [
    ...Object.values(hub.queries ?? {}),
    ...Object.values(hub.mutations ?? {}),
    ...Object.values(resource.queries ?? {}),
    ...Object.values(resource.mutations ?? {}),
  ];
  const apiPending = all.some((q: any) => q?.status === 'pending');
  return apiPending || state.ui.manualLoading;
}
